const Joi = require("joi");

const loginSchema = (data) => {
  const schema = Joi.object({
    // UserName: Joi.string()
    //   .trim()
    //   .pattern(new RegExp("^[a-zA-Z0-9]+$"))
    //   .required()
    //   .max(30)
    //   .messages({
    //     "string.pattern.base": "Please enter valid UserName.",
    //     "string.max": "Please enter username with fewer than 30 characters.",
    //     "any.required": "Please enter Username.",
    //     "string.empty": "Please enter Username.",
    //   }),

    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .pattern(
        new RegExp(
          /^(?!.*\.\.)[a-zA-Z0-9._!#$*+%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
      )
      .required()
      .messages({
        "string.email": "Please enter valid email.",
        "string.pattern.base": "Please enter valid email.",
        "string.empty": "Please enter email.",
        "any.required": "Please enter email.",
      }),

    password: Joi.string()
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .required()
      .messages({
        "string.pattern.base":
          "Password should contain letter, numbers and minimum 8 characters.",
        "any.required": "Please enter password.",
        "string.empty": "Please enter password.",
      }),

    // authendication: Joi.string()
    //   .lowercase()
    //   .valid("mfa", "email")
    //   .required()
    //   .messages({
    //     "any.only": "Invalid authendication format.",
    //     "any.required": "authendication is required.",
    //   }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = loginSchema;
